import { Check, Link, Question } from '@phosphor-icons/react';
import { Banner } from 'client/components/Banner';
import { Button } from 'client/components/Button';
import { Dialog } from 'client/components/Dialog/Dialog';
import { Stack } from 'client/components/Stack';

export interface ProjectDomainDialogProps {
  open: boolean;
  onSave: () => void;
  onClose: () => void;
}

export const ProjectDomainDialog = ({ open, onSave, onClose }: ProjectDomainDialogProps) => (
  <Dialog
    open={open}
    title="Change the parent domain?"
    description="This change might have unintended side effects."
    icon={<Link />}
    iconOrnament={<Question />}
    actions={
      <>
        <Button onClick={onClose}>Cancel</Button>
        <Button primary icon={<Check weight="bold" />} autoFocus onClick={onSave}>
          Change
        </Button>
      </>
    }
    onClose={onClose}
  >
    <Stack>
      <Banner type="warning">
        You are about to change the parent domain. This will change all deployment endpoints in this project set to the default generated
        domain.
      </Banner>
      <Banner type="info">
        Previous endpoints will no longer work. If any links to them have been saved somewhere, they will have to be updated.
      </Banner>
    </Stack>
  </Dialog>
);
